import { useTranslation } from "react-i18next";
import { AutoComplete } from "components/AutoComplete";
import { useRegion_v2 } from "contexts/regions_v2";

const RegionSelector = () => {
  const { t } = useTranslation();
  const {
    availableCities,
    availableJurisdictions,
    citiesLoading,
    provincesLoading,
    allProvinces,
    jurisdictionsLoading,
    setSelectedRegion,
    selectedRegion,
  } = useRegion_v2();

  return (
    <div className={"flex gap-x-2 w-full max-w-[480px]"}>
      <AutoComplete
        onSelectItem={() => {
          // setIsShowSuggestionDetailAccount(false);
        }}
        defaultSelected={selectedRegion.province}
        // defaultSelected={{
        //   code: value || "",
        //   name: value || "",
        // }}
        onSelect={(value: any) => {
          setSelectedRegion((prev) => ({
            ...prev,
            province: value,
            city: undefined,
            jurisdiction: undefined,
          }));
        }}
        optionLabel="name"
        // suggestions={
        //   accountCodeStateHook?.detailAccount || [{ code: "", name: "" }]
        // }
        suggestions={allProvinces}
        // onInputChange={debounce((inputValue) => {
        //   // setAccountCodeStateHook({
        //   //   typedDetailAccount: inputValue,
        //   // });
        // }, 350)}
        placeholder={t("province")}
        // hasLabel={false}
        // disabled={!watch(`titleCode`) || !watch(`headingCode`)}
        className="w-1/3 bg-gray-00"
        // inputTooltip={
        //   accountCodeStateHook?.detailAccount?.find(
        //     (item) => item.code === value
        //   )?.name
        // }
        onClear={() => {
          // setAccountCodeStateHook({
          //   selectedDetailAccount: undefined,
          // });
          // onChange(null);
        }}
        loading={provincesLoading}
        // error={Boolean(errors.detailAccountCode)}
        parentBackgroundColor={"bg-neutral-20"}
      />
      <AutoComplete
        onSelectItem={() => {
          // setIsShowSuggestionDetailAccount(false);
        }}
        defaultSelected={selectedRegion.city}
        // defaultSelected={{
        //   code: value || "",
        //   name: value || "",
        // }}
        onSelect={(value: any) => {
          setSelectedRegion((prev) => ({
            ...prev,
            city: value,
            jurisdiction: undefined,
          }));
        }}
        optionLabel="name"
        // suggestions={
        //   accountCodeStateHook?.detailAccount || [{ code: "", name: "" }]
        // }
        suggestions={availableCities}
        // onInputChange={debounce((inputValue) => {
        //   // setAccountCodeStateHook({
        //   //   typedDetailAccount: inputValue,
        //   // });
        // }, 350)}
        placeholder={t("city")}
        hasLabel={false}
        // disabled={!watch(`titleCode`) || !watch(`headingCode`)}
        className="w-1/3 bg-gray-00"
        // inputTooltip={
        //   accountCodeStateHook?.detailAccount?.find(
        //     (item) => item.code === value
        //   )?.name
        // }
        onClear={() => {
          // setAccountCodeStateHook({
          //   selectedDetailAccount: undefined,
          // });
          // onChange(null);
        }}
        loading={citiesLoading}
        // error={Boolean(errors.detailAccountCode)}
        disabled={!selectedRegion.province}
        parentBackgroundColor={"bg-neutral-20"}
      />
      <AutoComplete
        onSelectItem={() => {
          // setIsShowSuggestionDetailAccount(false);
        }}
        defaultSelected={selectedRegion.jurisdiction}
        // defaultSelected={{
        //   code: value || "",
        //   name: value || "",
        // }}
        onSelect={(value: any) => {
          setSelectedRegion((prev) => ({
            ...prev,
            jurisdiction: value,
          }));
        }}
        optionLabel="name"
        // suggestions={
        //   accountCodeStateHook?.detailAccount || [{ code: "", name: "" }]
        // }
        suggestions={availableJurisdictions}
        // onInputChange={debounce((inputValue) => {
        //   // setAccountCodeStateHook({
        //   //   typedDetailAccount: inputValue,
        //   // });
        // }, 350)}
        placeholder={t("jurisdiction")}
        hasLabel={false}
        // disabled={!watch(`titleCode`) || !watch(`headingCode`)}
        className="w-1/3 bg-gray-00"
        // inputTooltip={
        //   accountCodeStateHook?.detailAccount?.find(
        //     (item) => item.code === value
        //   )?.name
        // }
        onClear={() => {
          // setAccountCodeStateHook({
          //   selectedDetailAccount: undefined,
          // });
          // onChange(null);
        }}
        loading={jurisdictionsLoading}
        // error={Boolean(errors.detailAccountCode)}
        disabled={!selectedRegion.city}
        parentBackgroundColor={"bg-neutral-20"}
      />
    </div>
  );
};

export default RegionSelector;
